module.exports = __webpack_public_path__ + "img/matt_h.5972121d.png";